interface DropOffBottomSheetProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  onExplorePress?: () => void;
  dropOffData?: any;
  showOnLand?: boolean;
  onGoBack?: () => void;
}
import {
  Backdrop,
  BtnWrap,
  DragHandle,
  DragHandleWrap,
  HeroImage,
  ImageWrap,
  ListCard,
  ListContent,
  ListIcon,
  ListText,
  ListWrap,
  Overlay,
  PrimaryBtn,
  SecondaryBtn,
  Sheet,
  Title,
  TitleWrap,
} from "./Styles";
import FormattedText from "../../../FormattedText/FormattedText";

export const DropOffBottomSheet = ({
  visible,
  setVisible,
  onExplorePress,
  dropOffData,
  showOnLand = false,
  onGoBack,
}: DropOffBottomSheetProps) => {
  if (!visible) return null;

  const hasImage = Boolean(dropOffData?.img);
  const hasList = Array.isArray(dropOffData?.list) && dropOffData.list.length > 0;
  const hasPrimary = Boolean(dropOffData?.ctaText?.title);
  const hasSecondary = Boolean(dropOffData?.secondaryCtaText?.title);

  const onOverlay = () => setVisible?.(false);
  const onPrimary = () => {
    onExplorePress?.();
    setVisible?.(false);
  };
  const onSecondary = () => {
    setVisible?.(false);
    if (!showOnLand) onGoBack?.();
  };

  return (
    <Overlay>
      <Backdrop onClick={onOverlay} aria-label="close dropoff sheet" />
      <Sheet>
        {hasImage ? (
          <ImageWrap>
            <HeroImage src={dropOffData?.img} alt="dropoff" />
            <DragHandleWrap>
              <DragHandle />
            </DragHandleWrap>
          </ImageWrap>
        ) : (
          <DragHandle />
        )}

        {dropOffData?.title ? (
          <TitleWrap>
            <Title>
              <FormattedText value={dropOffData.title} />
            </Title>
          </TitleWrap>
        ) : null}

        {hasList ? (
          <ListWrap>
            {dropOffData.list.map((item: any, index: number) => (
              <ListCard key={`dropoff-item-${index}`}>
                {item?.img ? <ListIcon src={item.img} alt="item" /> : null}
                <ListContent>
                  <ListText>
                    <FormattedText value={item?.des} />
                  </ListText>
                </ListContent>
              </ListCard>
            ))}
          </ListWrap>
        ) : null}

        <BtnWrap>
          {hasPrimary ? (
            <PrimaryBtn onClick={onPrimary}>
              <FormattedText value={dropOffData.ctaText.title} />
            </PrimaryBtn>
          ) : null}
          {hasSecondary ? (
            <SecondaryBtn onClick={onSecondary}>
              <FormattedText value={dropOffData.secondaryCtaText.title} />
            </SecondaryBtn>
          ) : null}
        </BtnWrap>
      </Sheet>
    </Overlay>
  );
};

